<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%; width: 100%;">
		<!--input类型示例-->
		<FormItem prop="IP" style="width: 25%;">
			<Input type="text" v-model="formInline.Ip" placeholder="IP">
			<span slot="prepend">IP</span>
			</Input>
		</FormItem>
		<FormItem prop="Port" style="width: 13%;">
			<Input type="text" v-model="formInline.Port" :placeholder="$tt('端口')">
			<span slot="prepend">{{$tt('端口')}}</span>
			</Input>
		</FormItem>
		<FormItem prop="Path" style="width: 16%;">
			<Input type="text" v-model="formInline.Path" :placeholder="$tt('路径')">
			<span slot="prepend">{{$tt('路径')}}</span>
			</Input>
		</FormItem>
		<FormItem prop="UserName" style="width: 23%;">
			<Input type="text" v-model="formInline.UserName" :placeholder="$tt('用户名')">
			<span slot="prepend">{{$tt('用户名')}}</span>
			</Input>
		</FormItem>
		<FormItem prop="UserPwd" style="width: 13%;">
			<Input type="password" v-model="formInline.UserPwd" :placeholder="$tt('密码')">
			<span slot="prepend">{{$tt('密码')}}</span>
			</Input>
		</FormItem>
		<FormItem prop="FileVersion" style="width: 23%;">
			<Input type="text" v-model="formInline.FileVersion" :placeholder="$tt('版本号')">
			<span slot="prepend">{{$tt('版本号')}}</span>
			</Input>
		</FormItem>
		<FormItem prop="Remark" style="width: 23%;">
			<Input type="text" v-model="formInline.Remark" :placeholder="$tt('备注')">
			<span slot="prepend">{{$tt('备注')}}</span>
			</Input>
		</FormItem>
		<FormItem prop="Member">
			<div style="float: right;width: 100%;">
				<Upload name="UpFile" :data="formInline" :show-upload-list="false" :format="['bin', 'sbin']"
					:action="uploadUpgradeFileUrl" :headers="upHeader" :on-format-error="formatError"
					:before-upload="uploadBefore" :on-error="uploadError" :on-success="uploadSuccess">
					<Button icon="ios-cloud-upload-outline">{{$tt('上传文件')}}</Button>
				</Upload>
			</div>
		</FormItem>
		<FormItem>
			<Button type="error" @click="$emit('delFile')">{{$tt('删除文件')}}</Button>
		</FormItem>
	</Form>
</template>

<script>
	import webapi from '../../../../webapi';
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				uploadUpgradeFileUrl: webapi.base_api_url + '/System/UploadUpgradeFile',
				formInline: {
					FileVersion: '',
					Ip: '192.168.9.9',
					Port: '8021',
					Path: '/12/45',
					UserName: 'user',
					UserPwd: '123456',
					Remark: '',
				},
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
			};
		},
		created() {
			this.GetFtpParam()
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
		},
		methods: {
			GetFtpParam: function() {
				const _this = this
				_this.$axios.post(webapi.base_api_url + "/System/GetFtpParam", {}).then(res => {
					if (res.data.Code == 0) {
						this.formInline = res.data.Data;
					}
				})
			},
			//上传文件
			uploadSuccess: function(response, file, fileList) {
				console.log("上传文件成功")
				this.formInline.FileVersion = ''
				this.$emit('handleSubmitFile')
			},
			//上传文件error
			uploadError: function(response, file, fileList) {
				this.$Message.error(this.$tt('上传文件失败'))
				this.formInline.FileVersion = ''
			},
			//上传文件检查
			uploadBefore: function(file) {
				if (this.formInline.FileVersion == '') {
					this.$Message.error(this.$tt('请填写文件版本号'))
					return false;
				}
			},
			formatError: function(file, fileList) {
				this.$Message.error(this.$tt('文件格式为.bin或.sbin'))
			},
		},
	}
</script>

<style>
</style>